import React, { cloneElement } from "react";
import { jsx, css } from "@emotion/react";

const styles = {
  container: css`
    /* height: 40px; */
    /* position: relative; */
    margin-bottom: 8px;
    text-align: center;

    display: flex;
    flex-direction: column;
    overflow-y: hidden;
  `,
};

const PopoverContent = (props) => {
  return <div css={styles.container}>{props.children}</div>;
};

export default PopoverContent;
